/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { BORDER_STYLE } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getSCSSDifference } from "src/libs/utilities/getCssDemention"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import "../../../assets/css/HTML.scss"
import { ALIGN, HTMLContent, ILandingSection, LANDING_TYPE_CONTENT, SCROLLING_TYPE, SELECT_TYPE, TEXT_ALIGN } from "../../../data/interfaces"
import DataContentEditor from "../landing-edit/editors/data-content-editor"
import { DataContentPrimitive, HTMLPrimitive } from "../primitive"
import LinkContainer from "../useful/LinkContainer"
import More from "../useful/More"
import TextBlock from "../useful/TextBlock"
import Dummy from "./Dummy"
import { getID } from "src/libs/utilities"
import Incut from "./html/Incut"

/* Protopia Ecosystem component */
export interface IHTMLProps {
   section: ILandingSection
   data: HTMLContent 
}
const HTML = ({data, ...props}: IHTMLProps): JSX.Element => {
    const {position}          = usePosition(data)
    const [marginLeft]      = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]     = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]       = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    
    const [gap]             = useState<string>(getCssDemention( data.gap, "20px" ))
    const [height, setHeight]       = useState<string>(getCssDemention( position.height || data.height, "fit-content" ))
    const [width]                   = useState<string>(getCssDemention( position.width || data.width, "100%" ))
    const [padding]                 = useState<string>(getCssDemention( data.padding, "0" ))
    const [borderRound]             = useState<string>(getCssDemention( data.incutBorder?.borderRound?.border, "0" ))
    
    useEffect(() => {
        addCSSClass(
            `landing-html-${data.id}`,
            `.landing-html-${data.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                text-align:${ TEXT_ALIGN[ data.text_align || ALIGN.START] }; 
                max-height: ${ height };
                height: ${ height };
                ${ data.text_size ? `font-size: ${ data.text_size }px;` : "" }
                ${ data.text_color ? `color: ${ data.text_color };` : "" };
                ${ data.font ? `font-family: ${data.font};` : "" };
                ${ data.font_case ? `text-transform: ${data.font_case };` : "" }
                ${ data.line_height ? `line-height: ${data.line_height };` : "" }
                ${ data.letter_spacing ? `letter-spacing: ${data.letter_spacing }px;` : "" }
                ${ data.font_weight ? `font-weight: ${data.font_weight };` : "" }
                ${ data.font_style ? `font-style: ${data.font_style };` : "" }
                transition: 400ms all ease-out;
                ---background-color: ${data.background || "transparent"};
                padding: ${padding};
                z-index:1;
                & > div {
                    column-gap:${gap}px;
                }
            }
            .landing-more-${data.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                z-index:1;
            }
            .link-${data.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: 100%;
                max-height: ${ height };
                height: ${ height };
                z-index:1;
            }
            .incut1-${data.id} { 
                padding: ${ gap };
                width:  ${getCssDemention( data.incutWidth,  "350px" )};
                height: ${getCssDemention( data.incutHeight, "300px" )};
                --border: 1px solid var(--force-contast-color); 
                border-width: ${data.incutBorder?.borderWidth || 0}px;
                border-color: ${data.incutBorder?.borderColor};
                border-style: ${data.incutBorder?.borderStyle || BORDER_STYLE.SOLID} ;
                border-radius: ${borderRound};
            }
            `
        )
        
        return () => {
            removeCSSClass(`landing-html-${data.id}`)
        }
    },[ data, height, padding, borderRound ])
  
    return <div 
        className={`pe-html-container landing-content-container`} 
        style={{
            backgroundColor: data.background || "transparent" 
        }}
        data-type={data.type} 
        data-content-id={data.id}
    >
        {
            !!data.text
                ?
                <>
                    <LinkContainer
                        link_url={data.link_url}
                        link_target={data.link_target}
                        className={`link-${data.id}`}
                        data-primitive-type={ LANDING_TYPE_CONTENT.HTML } 
                    >
                        <div className={ `landing-html-${data.id} ${data.className} ${ !data.wrapped ? ( data.scroling || SCROLLING_TYPE.Y ) : "overflow-hidden" }` } style={ data.style } >
                            <HTMLPrimitive
                                primitive={data}
                                section={props.section}
                            />
                        </div>
                    </LinkContainer> 
                    <DataContentEditor data={data} section={props.section}  />
                </>
                :
                <Dummy {...{ 
                    ...{
                        data: {
                            ...data,
                            className: ` ${data.className} landing-html-${data.id} `
                        },
                    }, 
                    ...props 
                }} />
        }
        
    </div>
}
export default HTML

export const getDifferent = (type: string): number => {
    switch(type) {
        case LANDING_TYPE_CONTENT.IMAGE:
        case LANDING_TYPE_CONTENT.HTML:
            return 0
        default: 
            return 40 
    }
}